import React from 'react';

interface ButtonGroupProps<T> {
  items: { label: string; value: T }[]; // Her buton için etiket ve değer
  selected: T; // Seçili öğe
  onSelect: React.Dispatch<React.SetStateAction<T>>; // Tıklama olayı
  buttonClassName?: string; // Opsiyonel: CSS sınıfı
  activeClassName?: string; // Opsiyonel: Seçili durum için CSS sınıfı
}

function ButtonGroup<T>({
  items,
  selected,
  onSelect,
  buttonClassName = '',
  activeClassName = 'active',
}: ButtonGroupProps<T>) {
  return (
    <div className="flex">
      {items.map((item) => (
        <button
          key={String(item.value)} // key için değer string'e dönüştürüldü
          className={`obro-btn obro-light-gray-btn ${buttonClassName} ${
            selected === item.value ? activeClassName : ''
          }`}
          onClick={() => onSelect(item.value)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}

export default ButtonGroup;
